import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const EnableRecurringBookingsModal = Loadable({
  loader: () => import('../../pages/calendar/enable_recurring_bookings_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('EnableRecurringBookingsModal', EnableRecurringBookingsModal);
